export default __webpack_public_path__ + "static/media/AccountingLogo.1a6c5182.png";